import { render } from "./ModulesSidebar.vue?vue&type=template&id=cd7b1746&scoped=true"
import script from "./ModulesSidebar.vue?vue&type=script&lang=js"
export * from "./ModulesSidebar.vue?vue&type=script&lang=js"

import "./ModulesSidebar.vue?vue&type=style&index=0&id=cd7b1746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7b1746"]])

export default __exports__